import { UploadFile, UploadProps } from "antd";
import { GetProp } from "antd/lib";
type FileType = Parameters<GetProp<UploadProps, "beforeUpload">>[0];

export const handleError = (e: unknown) => {
  let message = "Unknown Error";
  if (e instanceof Error) {
    message = e.message;
  }
  throw message;
};

const INVALID_TYPES = [null, undefined, NaN];

export const convertObjectToFormData = (obj: Object) => {
  const formData = new FormData();
  Object.entries(obj).forEach(([key, value]) => {
    let arrayHasValues = true;
    if (Array.isArray(value)) {
      arrayHasValues = !!value.length;
      value = JSON.stringify(value);
    }
    const hasValue = !INVALID_TYPES.includes(value);
    if (arrayHasValues && hasValue) {
      formData.append(key, value as string);
    }
  });
  return formData;
};

export const downloadFile = (file: Blob, name: string) => {
  const url = window.URL.createObjectURL(new Blob([file]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", name);
  document.body.appendChild(link);
  link.click();
  URL.revokeObjectURL(url);
};

export const addFilesToBody = (formData: FormData, files?: UploadFile[]) => {
  if (files?.length) {
    files.forEach((file) => {
      const name = encodeURI(file.name);
      formData.append(name, file as FileType);
    });
  }
};
